const MONTHS = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];

/* Madrid calendar date from numeric parts only: identical on the prerender
   server and in any browser, so hydration never sees a different string. */
function madridParts(iso: string) {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Madrid",
    day: "numeric",
    month: "numeric",
    year: "numeric",
  }).formatToParts(new Date(iso));
  const get = (type: string) => Number(parts.find((part) => part.type === type)?.value);
  return { day: get("day"), month: get("month"), year: get("year") };
}

/** “12 de septiembre de 2026”. */
export function formatBlogDate(iso: string): string {
  const { day, month, year } = madridParts(iso);
  return `${day} de ${MONTHS[month - 1]} de ${year}`;
}

const SHORT_MONTHS = ["ene.", "feb.", "mar.", "abr.", "may.", "jun.", "jul.", "ago.", "sept.", "oct.", "nov.", "dic."];

/** “12 sept. 2026”, for cards. */
export function formatBlogDateShort(iso: string): string {
  const { day, month, year } = madridParts(iso);
  return `${day} ${SHORT_MONTHS[month - 1]} ${year}`;
}

export function sameMadridDay(a: string, b: string): boolean {
  const x = madridParts(a);
  const y = madridParts(b);
  return x.day === y.day && x.month === y.month && x.year === y.year;
}

export function readingTime(minutes: number): string {
  return `${minutes} min de lectura`;
}
